import { AxiosResponse } from 'axios';
import { URL_ENDPOINTS } from '../constants';
import TokenService from './TokenStorage';
import { axiosInstance as Api } from '../api/api-helper';
import { SignatureData } from '../interfaces/Signature';

const URL = URL_ENDPOINTS.BASE_URL + URL_ENDPOINTS.SIGNATURE;

export const SignatureService = {
  getSignature: async (): Promise<SignatureData> => {
    const accessToken = TokenService.getToken();
    const response = await Api.get(URL, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  },
};
